import { ViewContainerRef } from '@angular/core';

import { SnLonLatLike } from '@lib/geo/helpers';

export interface IFsMapPopupOptions<TData = any> {
  data?: TData;
  viewContainerRef?: ViewContainerRef;
  maxWidth?: number;
  disableAutoPan?: boolean;
  lonLat?: SnLonLatLike;
  offset?: IFsMapOffset;
  id?: string;
}

export interface IFsMapOffset {
  width: number;
  height: number;
  unit?: string;
}
